module.exports = __webpack_public_path__ + "static/media/logo.896f14a0.png";